import { checkImportExact, clearExistingScheduledImports} from './import';
import { getCookie, getCurrentUser, enableUpdateImports, updateUserLastAction } from './utils';

// Handles exactonline import execution on the server
export async function handleImport(row, updateStatus){
  // await checkImportExact(data[id].entiteit, data[id].year, data[id].budget_scenario, office);
  try {
    handleStatus(updateStatus);

    const response = await fetch('/eboekhouden/handleImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify(
        row
      ),
    });
    if (response.ok) {
      // const responseData = await response.json();  
      // return responseData;
      await enableUpdateImports();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    handleStatus({"text": "Error!", "progress": 1, "status": 0});
  }
}

export async function getEboekhoudenCompany(){
  var config = await getEboekhoudenConfig(await getCurrentUser());
  const response = await fetch('/eboekhouden/getCompany', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config),
  });
  if (response.ok) {
    const responseData = await response.json();

    if(responseData){
      return responseData;
    }
  }
}

export async function getAdministrations(){
  var config = await getEboekhoudenConfig(await getCurrentUser());
  const response = await fetch('/eboekhouden/getAdministration', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config)
  });
  if (response.ok) {
    const responseData = await response.json();

    if(responseData){
      var administrations = [];
      for(var i = 0; i < responseData.length; i++){
        var adminObj = {"Description": responseData[i].description, "Code": responseData[i].code, "type":'administration'};
        administrations.push(adminObj);
        await updateImportEboekhoudenByOffice(responseData[i].code);
      };

      return administrations;
    }
  }
}

async function findByDivision(office){
  var response = await fetch('/import_eboekhouden/getListArray?division='+office);
  if(response.ok){
    var responseData = response.json();
    return responseData;
  }
}

// Update import exact factview and exactonline tokens
export async function updateImportEboekhoudenByOffice(office){
  var imp = await findByDivision(office);
  if(imp){
    for(var i = 0; i < imp.length; i++){
      await fetch('/import_eboekhouden/updateImportEboekhoudenTokens', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: imp[i].id,
          factview_access: getCookie('factview_access'),
          factview_refresh: getCookie('factview_refresh'),
          exact_access: getCookie('exact_access'),
          exact_refresh: getCookie('exact_refresh'),
        }),
      });  
   }
  }
  
}
export async function getEboekhoudenConfig(currentUser){
  try{
    const response = await fetch('https://api2.factview.nl/user/getEboekhouden?currentUser='+currentUser, {
      method: 'GET',
      headers: {
        'authorization': 'Bearer '+ getCookie("factview_access"),
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      }
    });

    if (response.ok) {
      const responseData = await response.json();

      if(responseData){
        
        return responseData;
      }
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

export async function getImportEboekhouden(mvLink){
  try{
    const response = await fetch('/eboekhouden/getImportEboekhouden', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        eboekhouden_link: mvLink
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function createImport(importConfig){
  try{
    const response = await fetch('/eboekhouden/createImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(importConfig),
    })
    if (response.ok) {
      const responseData = await response.json();
      updateUserLastAction();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}



//Submits import eboekhouden updates/changes
export async function updateImportEboekhouden(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_eboekhouden/updateImportEboekhouden', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImportEboekhouden(id){
  try { 
    // var importData = data.filter(item => item.id == id)[0];
    const importResponse = await fetch('/import_eboekhouden/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();

      await clearExistingScheduledImports({"import_type": "eboekhouden", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]});
    
      const response = await fetch('/import_eboekhouden/deleteImportEboekhouden?id='+id);
      if (response.ok) {
      const responseData = await response.json();
      
      if(responseData){
      }
    }
    
    }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}

// Handles fetching status updates from the server
async function handleStatus(updateStatus){
  const response = await fetch('/eboekhouden/fetchUpdates');

  if (response.ok) {
    const responseData = await response.json();
    
    if(responseData){
      updateStatus(responseData);

      if(responseData.length > 0 && responseData[responseData.length-1]["status"] == 1){
        setTimeout(function(){
          handleStatus(updateStatus);
        },250);
      }
    } 
  }
}


